import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-explore-two-section',
  templateUrl: './explore-two-section.component.html',
  styleUrls: ['./explore-two-section.component.scss']
})
export class ExploreTwoSectionComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
